import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import HostAMachine from "@/pages/HostAMachine";
import Locations from "@/pages/Locations";

function App() {
  return (
    <div className="App bg-[#0A0B10] text-white min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/hostamachine" element={<HostAMachine />} />
          <Route path="/locations" element={<Locations />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
